import axios from "axios";
import { environment } from "../../../environments/environment";

export function getVendorOrders(companyId, search, page, orderBy, filters) {
    let params = new URLSearchParams();
    params.append("page", page)
    params.append("pageSize", environment.ElemensPerPage)
    params.append("search", search)
    params.append("orderBy", orderBy)
    return axios.post(`${environment.getVendorOrders}?${params.toString()}`, [
        { "columnName": "companyId", "value": companyId },
        ...(filters ?? [])
    ])
}
export function approveOrderReq(orderId) {
    return axios.put(`${environment.approveOrder}?id=${orderId}`);
}
export function rejectOrderReq(orderId, reason) {
    return axios.put(`${environment.rejectOrder}?id=${orderId}`,{reason});
}

export function getOrderDetails(orderId, companyId) {
    let params = new URLSearchParams()
    params.append("page", 0)
    params.append("pageSize", environment.ElemensPerPage)
    params.append("search", "")
    params.append("orderBy", "")

    return axios.post(`${environment.getOrderDetails}?${params.toString()}`,
        [
            {
            columnName: "companyId",
            value: parseInt(localStorage.getItem("u_company_id")),


        },
        {
            "columnName": "parentId",
            "value": orderId,
        }]
    )
    return axios.post(`${environment.getOrdersListDetails}${params.toString()}`,
        [{
            columnName: "company_id",
            value: [parseInt(localStorage.getItem("u_company_id"))],
            // value: [parseInt(data?.company_id)],


        },
        {
            "columnName": "parent_order_id",
            "value": [orderId],
        }]
    )
}

export function getDetailsByAwb(awb, companyId) {
    let params = new URLSearchParams()
    params.append("page", 0)
    params.append("pageSize", environment.ElemensPerPage)
    params.append("search", "")
    params.append("orderBy", "")

    return axios.post(`${environment.getOrderDetails}?${params.toString()}`,
        [{
            columnName: "companyId",
            value: parseInt(localStorage.getItem("u_company_id")),
            // value: [parseInt(data?.company_id)],


        },
        {
            "columnName": "awb_number",
            "value": awb,
        }]
    );
}
export function getDetailsByStatus(status, search, page, orderBy, companyId) {
    let params = new URLSearchParams()
    params.append("page", page ?? 0)
    params.append("pageSize", environment.ElemensPerPage)
    params.append("search", search || "")
    params.append("orderBy", `${orderBy ? `${orderBy},`: ""}status`);

    return axios.post(`${environment.getOrderDetails}?${params.toString()}`,
        [{
            columnName: "companyId",
            value: parseInt(localStorage.getItem("u_company_id")),
            // value: [parseInt(data?.company_id)],


        },
        {
            "columnName": "status",
            "value": status,
        }]
    );
}

export function saveAwbObj(awbObj) {
    return axios.post(environment.saveAwbObj, awbObj);
    // return Promise.resolve({data: {responseCode: 200}});
}
export function saveOrderInfoReq(orderInfo) {
    return axios.post(environment.saveOrderInfo, orderInfo);
    // return Promise.resolve({data: {responseCode: 200}});
}
export function getOrderInfoReq(anvoId) {
    return axios.get(`${environment.getOrderInfo}?id=${anvoId}`);
    // return Promise.resolve({data: {responseCode: 200}});
}